import isSameDay from 'date-fns/isSameDay'
import { getDateFromString } from '../date/getDateFromString'
import dateFormats from './date-formats.json'
import { formatDate } from '../date/format'
import { capitalize } from '../capitalize'

export function getDateTimeString(node, lang = 'en') {
  const { startDate: startDateStr, endDate: endDateStr } = node
  const format = dateFormats[lang]
  const startDate = startDateStr && getDateFromString(startDateStr)
  const endDate = endDateStr && getDateFromString(endDateStr)
  let str = endDate
    ? isSameDay(startDate, endDate)
      ? format['fromToSameDay']
      : format['fromTo']
    : format['from']

  if (startDate) {
    str = str.replace('{{start}}', formatDate(startDate, format['start'], lang))
  }

  if (startDate && endDate) {
    str = str.replace(
      '{{end}}',
      formatDate(
        endDate,
        isSameDay(startDate, endDate) ? format['endSameDay'] : format['end'],
        lang
      )
    )
  }

  return capitalize(str)
}
